// TRAYD PAGE
export const traydContent = {
  pageMaxWidth: '1200px',
  breadcrumb: {
    text: 'Back to Home',
    url: '/'
  },

  sections: [
    {
      id: 'hero',
      spacing: 'clamp(32px, 5vw, 64px)',
      blocks: [
        {
          type: 'container',
          narrow: true,
          blocks: [
            {
              type: 'custom',
              render: () => (
                <span style={{
                  background: 'linear-gradient(135deg, #0cebeb 0%, #20e3b2 50%, #29ffc6 100%)',
                  color: '#1a1a1a',
                  padding: '8px 20px',
                  borderRadius: '25px',
                  fontSize: '13px',
                  fontWeight: '600',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  display: 'inline-block'
                }}>
                  Mobile Apps
                </span>
              )
            }
          ]
        },
        { type: 'spacer', size: 'small' },
        { type: 'title', text: 'Trayd', size: 'h1' },
        {
          type: 'text',
          content: 'Mobile trading made intuitive',
          size: 'large'
        },
        { type: 'spacer', size: 'small' },
        {
          type: 'text',
          content: 'A mobile trading application with real-time market data, portfolio tracking, and streamlined trading experience.'
        },
        { type: 'spacer', size: 'small' },
        {
          type: 'custom',
          render: () => (
            <span style={{
              background: 'linear-gradient(135deg, #0cebeb 0%, #20e3b2 50%, #29ffc6 100%)',
              color: '#1a1a1a',
              padding: '12px 24px',
              borderRadius: '8px',
              fontWeight: '600'
            }}>
              In Development
            </span>
          )
        }
      ]
    },

    {
      id: 'features',
      title: 'Features',
      blocks: [
        {
          type: 'custom',
          render: () => (
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '24px'
            }}>
              {[
                { icon: '📈', title: 'Real-time Data', desc: 'Live market prices and charts' },
                { icon: '💼', title: 'Portfolio Tracking', desc: 'Monitor your investments in real-time' },
                { icon: '⚡', title: 'Quick Trading', desc: 'Execute trades with minimal friction' },
                { icon: '🔔', title: 'Price Alerts', desc: 'Get notified on price movements' }
              ].map((feature, i) => (
                <div key={i} style={{
                  background: 'var(--bg-secondary)',
                  padding: '24px',
                  borderRadius: '16px',
                  border: '1px solid var(--border-color)'
                }}>
                  <div style={{ fontSize: '2rem', marginBottom: '12px' }}>{feature.icon}</div>
                  <h3 style={{ color: 'var(--text-primary)', marginBottom: '8px', fontSize: '1.1rem' }}>{feature.title}</h3>
                  <p style={{ color: 'var(--text-secondary)', fontSize: '0.95rem', margin: 0 }}>{feature.desc}</p>
                </div>
              ))}
            </div>
          )
        }
      ]
    },

    {
      id: 'tech',
      title: 'Built With',
      blocks: [
        {
          type: 'custom',
          render: () => (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
              {['React Native', 'Expo', 'Trading APIs', 'WebSocket', 'Real-time Data'].map((tech, i) => (
                <span key={i} style={{
                  background: 'var(--bg-secondary)',
                  color: 'var(--text-primary)',
                  padding: '10px 20px',
                  borderRadius: '25px',
                  fontSize: '0.9rem',
                  border: '1px solid var(--border-color)'
                }}>{tech}</span>
              ))}
            </div>
          )
        }
      ]
    }
  ],

  callToAction: {
    title: 'Trayd',
    text: 'Trade smarter, not harder',
    button: { text: 'See more work →', url: '/' }
  }
};
